import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=387ce5c6&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"
import style0 from "./reservation.vue?vue&type=style&index=0&id=387ce5c6&prod&scoped=true&lang=scss"
import style1 from "./reservation.vue?vue&type=style&index=1&id=387ce5c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ce5c6",
  null
  
)

export default component.exports